;(function(){

	var block = 'variants';

	$(bem.selector(block)).each(function() {

		var
			$wrapper = $(this),
			$preview = $wrapper.find(bem.selector(block, 'preview')),
			$radios  = $wrapper.find(bem.selector(block, 'radio')),
			$img     = $wrapper.find(bem.selector(block, 'img-wrapper')),
			$select  = $wrapper.find('select' + bem.selector(block, 'select')),
			$active  = $(),
			$default = $img.children(),

			checked   = function() {
				return $radios.filter(':checked');
			},
			setSelect = function() {
				if (!$active.length) {
					return;
				}
				$select.val($active.val()).next('.select__label').text($active.data('name'));
			},
			setRadios = function() {
				if (!$active.length) {
					return;
				}
				$radios.prop('checked', function(i, value) {
					return $(this).val() === $active.val();
				});
			},
			scroll = function() {

				if (site.width >= 768) {
					return;
				}

				var top = $wrapper.find(bem.selector(block, 'container')).get(0)
					.getBoundingClientRect().top;

				if (top < 0) {
					return;
				}

				$core.win.scrollTop($core.win.scrollTop() + top);

			};

		if (!$select.children().length) {
			return;
		}

		$active = checked();

		$img.prepend($(bem.selector('loading')).children().clone().addClass(bem.states.active));
		$preview.data('default', $preview.text());

		$wrapper
			.on(bem.event(block, 'preview'), function() {

				$preview.text($active.length ? $active.data('name') : $preview.data('default'));

				if ($active.length) {

					var
						$activeImg = $img.children('[data-id=' + $active.val() + ']'),
						filename   = $active.data('img-filename');

					if (!$activeImg.length && !!filename) {

						$img.append($('<img />').attr({
							class:     'placeholder__img is-hidden ' + bem.selector(block, 'img').replace('.', ''),
							src:       $img.data('url-prefix') + filename + $img.data('url-suffix'),
							alt:       $active.data('name'),
							'data-id': $active.val()
						}));

					}

				}

				$default.toggleClass(bem.states.hidden, !!$active.length && !!filename);

				$img.children(bem.selector(block, 'img')).each(function() {
					var $this = $(this);
					$this.toggleClass(bem.states.hidden, $this.data('id').toString() !== $active.val());
				});

			})
			.on('change', 'select' + bem.selector(block, 'select'), function() {

				$active = $radios.filter('[value=' + $select.val() + ']');
				setRadios();
				$wrapper.trigger(bem.event(block, 'preview'));

			})
			.on('click', bem.selector(block, 'radio'), function() {

				$active = checked();
				setSelect();
				scroll();
				$wrapper.trigger(bem.event(block, 'preview'));

			})
			.on('mouseenter', bem.selector(block, 'label'), function() {

				if (Modernizr.touchevents) {
					return;
				}

				$active = $(this).prev(bem.selector(block, 'radio'));
				$wrapper.trigger(bem.event(block, 'preview'));

			})
			.on('mouseleave', bem.selector(block, 'label'), function() {

				if (Modernizr.touchevents) {
					return;
				}

				$active = checked();
				$wrapper.trigger(bem.event(block, 'preview'));

			});

	});

}());
